import Logo from "../../assets/images/new-logo.svg";
import LanguageSwitcher from "@iso/containers/LanguageSwitcher/LanguageSwitcher";

export function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-md">
      <div className="mx-auto py-6 px-8 flex justify-between items-center">
        <a className="navbar-brand" href="/">
          <img src={Logo} alt="Docplanner Group" width={100} />
        </a>
        <LanguageSwitcher />
      </div>
    </nav>
  );
}
